import { createContext, CSSProperties, FC, useContext, useEffect, useState } from "react";

interface FireAlarmContextType {
  isFireAlarmActive: boolean;
  activateFireAlarm: () => void;
  deactivateFireAlarm: () => void;
}

const FireAlarmContext = createContext<FireAlarmContextType | undefined>(undefined);

type FireAlarmProviderProps = {
  children: React.ReactNode;
}

export const FireAlarmProvider: FC<FireAlarmProviderProps> = ({ children }) => {
  const [isFireAlarmActive, setIsFireAlarmActive] = useState<boolean>(false);

  const activateFireAlarm = () => {
    setIsFireAlarmActive(true);
  }
  const deactivateFireAlarm = () => {
    setIsFireAlarmActive(false);
  }

  useEffect(() => {
    const body = document.querySelector('#root') as HTMLElement;
    if (!body) return;
    if (isFireAlarmActive) {
      body.classList.add('red-alarm');
    } else {
      body.classList.remove('red-alarm');
    }
  }, [isFireAlarmActive])
  return (
    <FireAlarmContext.Provider value={{
      isFireAlarmActive,
      activateFireAlarm,
      deactivateFireAlarm,
    }}>
      {children}
    </FireAlarmContext.Provider>
  )
}

export const useFireAlarmContext = (): FireAlarmContextType => {
  const context = useContext(FireAlarmContext);
  if (!context) {
    throw new Error("useFireAlarm must be used within a FireAlarmProvider");
  }
  return context;
}